// ButtonNextTask

const getNextTaskLong = (state) => {

  const questionIndex = state.questionIndex;
  const answerIndex = state.answerIndex;
  let taskNumber = state.taskNumber;
  taskNumber = taskNumber + 1;
  const answerOptions = state.answerOptions;
  const tasks = [...answerOptions[taskNumber - 1]];
  const newIndexRightAnswer = 0;
  const renderQuestion = tasks[newIndexRightAnswer][questionIndex].value;
  let getAnswers = [];

  for (let i = 0; i < tasks.length; i++) {
    getAnswers.push({ value: tasks[i][answerIndex].value, isGivenAnswer: "", id: i })
  }

  const renderAnswers = getAnswers.sort(() => 0.5 - Math.random());

  return {
    ...state,
    confirmed: false,
    taskNumber: taskNumber,
    taskStatus: 'taskNumber',
    tasks: tasks,
    renderQuestion: renderQuestion,
    renderAnswers: renderAnswers,
    indexRightAnswer: newIndexRightAnswer,
    score: 0,
    btnInact: false,
  }
}

export default getNextTaskLong